var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticStyle:{"position":"absolute","left":"-9999px"},attrs:{"src":"https://top-fwz1.mail.ru/counter?id=3317020;js=na"}})])}]

export { render, staticRenderFns }